module.exports = __webpack_public_path__ + "img/tomato-rice-1.70e1d3c3.jpg";